export default "__VITE_ASSET__3u5vCvSo__"